// This module coordinates image preloading across our application
import { preloadAndCacheImage } from './imageCacheUtils';

// Cache keys for different image categories
export const CACHE_KEYS = {
  BIKE_CATEGORY: 'ridleyBikeCategoryImages',
  NOVINKY: 'ridleyNovinkyImages',
  GLOBAL: 'ridleyImageCache'
};

// Preload multiple images at once
export const preloadImages = (imageUrls, cacheKey, fallbackUrl) => {
  if (!Array.isArray(imageUrls) || imageUrls.length === 0) {
    return Promise.resolve([]);
  }
  
  const promises = imageUrls.map(url => 
    preloadAndCacheImage(url, cacheKey, fallbackUrl)
  );
  
  return Promise.all(promises);
};

// Check if we're returning to the home page
export const isReturningToHome = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return false;
  }
  
  return sessionStorage.getItem('returningToHome') === 'true';
};

// Clear the returning to home flag
export const clearReturningFlag = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }
  
  sessionStorage.removeItem('returningToHome');
};

// Check if all image caches exist
export const checkImageCaches = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return false;
  }
  
  const bikeCategoryCache = sessionStorage.getItem(CACHE_KEYS.BIKE_CATEGORY);
  const novinkyCache = sessionStorage.getItem(CACHE_KEYS.NOVINKY);
  
  return !!bikeCategoryCache && !!novinkyCache;
};

// Export a convenient API
const imagePreloadCoordinator = {
  preloadImages,
  isReturningToHome,
  clearReturningFlag,
  checkImageCaches,
  CACHE_KEYS
};

export default imagePreloadCoordinator;
